const registerTranslations = {
  en: {
    pageTitle: "Register",
    heroTitle: "Register",
    heroDesc: "Create your account",
    namePlaceholder: "Name",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password",
    registerBtn: "Register",
    registering: "Registering...",
    error: "Registration failed.",
    success: "Registration successful! You are now logged in.",
  },
  pa: {
    pageTitle: "ਰਜਿਸਟਰ ਕਰੋ",
    heroTitle: "ਰਜਿਸਟਰ ਕਰੋ",
    heroDesc: "ਆਪਣਾ ਖਾਤਾ ਬਣਾਓ",
    namePlaceholder: "ਨਾਮ",
    emailPlaceholder: "ਈਮੇਲ",
    passwordPlaceholder: "ਪਾਸਵਰਡ",
    registerBtn: "ਰਜਿਸਟਰ ਕਰੋ",
    registering: "ਰਜਿਸਟਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    error: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਅਸਫਲ।",
    success: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਸਫਲ! ਤੁਸੀਂ ਹੁਣ ਲੌਗਇਨ ਹੋ।",
  },
};

export default registerTranslations;
